module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"processing":"解析中..."},"en":{"processing":"Processing..."}}')
  delete Component.options._Ctor
}
